module.exports = __webpack_public_path__ + "img/user.c6c75f9e.svg";